import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQuery } from '@tanstack/react-query';

import type { ExtranetHotelContacts } from 'app/typings/core/extranet/hotel/contacts';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useHotelContacts(hotelId: number) {
  return useQuery({
    queryKey: [CORE_QUERY_KEYS.hotelContacts, { hotelId }],
    queryFn: () =>
      apiRequest({
        path: ENDPOINTS.getHotelContacts,
        params: { id: hotelId.toString() },
      }) as Promise<ExtranetHotelContacts>,
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
  });
}
